<template>
  <div class="cms-client-toast" :class="opacity">{{msg}}</div>
</template>
<script>
/**
 * 这里用了双向绑定。以及用setTimeout控制的过渡动画。被自己蠢哭了。。。。。。。其实可以用动画，然后监听动画结束事件
*/
export default {
  data() {
    return {
      opacity: ''
    }
  },
  props: {
    msg: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.opacity = 'show'
    }, 0)
    setTimeout(() => {
      this.opacity = 'hide'
    }, 1500)
    setTimeout(() => {
      this.$emit('input', false)
    }, 2000)
  }
}
</script>
<style lang="scss" scoped>
.cms-client-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s ease-in-out;
  opacity: 0;
  color: #fff;
  background-color: #333;
  padding: 0.5rem 1rem;
  z-index: 9999;
  &.show {
    opacity: 1;
  }
  &.hide {
    opacity: 0;
  }
}
</style>
